'use strict'
/**axios封装
 * 请求拦截，相应拦截，错误统一处理
 */
import Vue from 'vue';
import axios from 'axios';
import QS from 'qs';
import { Message } from 'element-ui'
import { stringTime } from '@/common/js/commont.js'

if(process.env.NODE_ENV == 'development') {
    console.log('开发')
    axios.defaults.baseURL = 'http://air.airdaas.com'
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'http://air.airdaas.com'
    console.log('生产')
}

// 请求超时时间
axios.defaults.timeout = 10000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        //添加公共参数
        // let data = QS.parse(config.data)
        // const token = localStorage.getItem('token')
        // const account = localStorage.getItem('account')
        // if(account) {
        //     data['account'] = account
        // }
        // if(token) {
        //     data['token'] = token
        // }
        // if(config.method === 'post') {
        //     config.data = QS.stringify({
        //         ...data
        //     })
        // }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if(response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器不是200的情况下
    error => {
        if(error.response.status) {
            switch(error.response.status) {
                case 401:
                    router.replace({
                        path: '/login',
                        query:{ redirect:router.currentRoute.fullPath}
                    });
                    break;
                    // 403 token过期
                    // 登录过期对用户进行提示
                    // 清除本地token
                    // 跳转登录页面
                case 403:
                  Message({
                    message: '登录过去，请重新登录',
                    type: 'warning',
                    duration: 1000
                  });
                  localStorage.removeItem('token');
                  // 跳转登录页面，并将要浏览的页面fullpath传过去，登录成功后跳转需要访问的页面
                  setTimeout(() => {
                    router.replace({
                        path: '/login',
                        query: {
                            redirect: router.currentRoute.fullPath
                        }
                    })
                  }, 1000);
                  break;
                  // 404请求不存在
                case 404:
                    Message({
                        message: '网络请求不存在',
                        duration: 1500,
                        type: 'warning',
                    });
                break;
                default:
                    Message({
                        message: 'error.response.data.message',
                        duration: 1500,
                        type: 'warning'
                    })
            }
            return Promise.reject(error.response)
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function get(url,params) {
    return new Promise((resolve,reject) => {
        axios.get(url,{
            params: params
        })
        .then(res => {
            resolve(res.data)
        })
        .catch(err => {
            reject(err.data)
        })
    })
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url,params) {
    return new Promise((resolve, reject) => {
        axios.post(url,params)
        .then(res => {
            resolve(res.data)
        })
        .catch(err => {
            reject(err.data)
        })
    })
}
export default axios